
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import AppLayout from "@/layouts/AppLayout.vue";
import { AxiosResponse } from "axios";
import moment from "moment";
import Loading from "@/components/Loading.vue";
import toast from "@/functions/toast.function";
import {
  data2blob,
  formDataAppend,
  isEmail,
} from "@/functions/global.function";
import {
  AdminJobFairAuthorizationEnum,
  AdminJobFairTypeEnum,
} from "@/constants/enum.constant";
import { WHATSAPP_LINK } from "@/constants/misc.constant";
import $ from "jquery";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

@Component({
  components: {
    Loading,
    AppLayout,
    VueCropper,
  },
  filters,
})
export default class CompanyRegister extends Vue {
  @Action("getCountry", { namespace: "admin" })
  private getCountry: any;
  @Action("getProvince", { namespace: "admin" })
  private getProvince: any;
  @Action("getCity", { namespace: "admin" })
  private getCity: any;
  @Action("getAdminJobFairDetail", { namespace: "admin" })
  private getAdminJobFairDetail: any;
  @Action("companyRegisterAdminJobFair", { namespace: "admin" })
  private companyRegisterAdminJobFair: any;

  @State("locale")
  private locale!: string;

  private cropper: any = null;
  private jobFair: any = null;
  private isLoadingJobFair = false;
  private isSubmitted = false;
  private imageCropper = false;
  private countries: Array<any> = [];
  private provinces: Array<any> = [];
  private cities: Array<any> = [];
  private name = "";
  private email = "";
  private phone = "";
  private logoFile: any = null;
  private logo: any = null;
  private logoPreview: any = null;
  private country: any = null;
  private province: any = null;
  private city: any = null;
  private description = "";
  private isOnSite = "";
  private boothNumber = "";
  private paymentProof: any = null;
  private npwp: any = null;
  private waLink = WHATSAPP_LINK;
  private users = [
    {
      name: "",
      email: "",
      phone: "",
      position: "",
    },
  ];
  private headlines = [
    {
      organizer: "SMK Islam PB Soedirman 2",
      name: "Career Day 2024",
      image: require("@/assets/images/job-fair/1.png"),
    },
    {
      organizer: "SMK Telkom Bandung",
      name: "Job Fair 2024",
      image: require("@/assets/images/job-fair/2.png"),
    },
    {
      organizer: "SMK YAJ Depok",
      name: "Job Fair 2024",
      image: require("@/assets/images/job-fair/3.png"),
    },
    {
      organizer: "SMKN 4 Jakarta",
      name: "Job & Edu Fair 2024",
      image: require("@/assets/images/job-fair/4.png"),
    },
    {
      organizer: "SMKN 33 Jakarta",
      name: "Exploring Tourism Careers",
      image: require("@/assets/images/job-fair/5.png"),
    },
    {
      organizer: "SMKN 69 Jakarta",
      name: "Job Fair Membara 2024",
      image: require("@/assets/images/job-fair/6.png"),
    },
    {
      organizer: "SMKS Assalam Depok",
      name: "Bursa Kerja 2024",
      image: require("@/assets/images/job-fair/7.png"),
    },
    {
      organizer: "Universitas Majalengka",
      name: "UNMA Career Expo 2024",
      image: require("@/assets/images/job-fair/8.png"),
    },
  ];

  @Watch("logo")
  private onTrigger() {
    if (typeof this.logo === "object")
      this.logoPreview = URL.createObjectURL(this.logo);
    else this.logoPreview = this.logo;
  }

  @Watch("country")
  private onCountry() {
    this.provinces = [];
    this.cities = [];
    this.province = null;
    this.city = null;

    if (this.country?.id) {
      this.getProvince({
        params: {
          country: this.country?.id,
        },
        success: (response: AxiosResponse) => {
          this.provinces = response.data.data;
        },
      });
    }
  }

  @Watch("province")
  private onProvince() {
    this.cities = [];
    this.city = null;

    if (this.province?.id) {
      this.getCity({
        params: {
          province: this.province?.id,
        },
        success: (response: AxiosResponse) => {
          this.cities = response.data.data;
        },
      });
    }
  }

  private get isEn() {
    return this.locale === "en";
  }

  private get isOneDay() {
    return moment(this.jobFair?.start_date).isSame(
      this.jobFair?.end_date,
      "day"
    );
  }

  private get isOrganization() {
    return this.jobFair?.type === AdminJobFairTypeEnum.ORGANIZATION;
  }

  private get canCompanyRegister() {
    return this.jobFair?.authorizations?.find(
      (value) => value.code === AdminJobFairAuthorizationEnum.COMPANY_REGISTER
    )?.is_allowed;
  }

  private created() {
    this.getData();

    this.getCountry({
      success: (response: AxiosResponse) => {
        this.countries = response.data.data;
        this.country = this.countries.find(
          (value) => value.name === "Indonesia"
        );
      },
    });
  }

  private getData() {
    this.isLoadingJobFair = true;
    this.getAdminJobFairDetail({
      params: {
        slug: this.$route.params.slug,
      },
      success: (response: AxiosResponse) => {
        this.jobFair = response.data.data;
        setTimeout(() => {
          this.scrollToElement("#headline-container");
        }, 300);
      },
      finally: () => {
        this.isLoadingJobFair = false;
      },
    });
  }

  private crop() {
    this.logo = new File(
      [
        data2blob(
          (this.$refs.cropper as any).getCroppedCanvas().toDataURL(),
          "image/png"
        ),
      ],
      `${Date.now().toString()}-cropped-image.png`
    );
  }

  private setImage(e) {
    const file = e.target.files[0];
    this.logoFile = file;

    if (file.type.indexOf("image/") === -1) {
      toast.warning("Please select an image file.");
      return false;
    }

    if (typeof FileReader === "function") {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.cropper = event.target.result;
        (this.$refs.cropper as any).replace(event.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      toast.warning("Sorry, FileReader API not supported.");
      return false;
    }
  }

  private scrollToElement(id) {
    $("html, body").animate(
      { scrollTop: ($(id) as any).offset().top - 90 },
      500
    );
  }

  private onlyNumber(event: any) {
    let keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode !== 43) {
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    }
  }

  private addUser() {
    this.users.push({
      name: "",
      email: "",
      phone: "",
      position: "",
    });
  }

  private deleteUser(index) {
    this.users.splice(index, 1);
  }

  private getExt(name: string, separator: string = ".") {
    const separatedName = name.split(separator);
    return separatedName[separatedName.length - 1];
  }

  private validate(field) {
    switch (field) {
      case "name":
        if (!this.name) {
          toast.warning("Silahkan masukkan nama perusahaan.");
          return false;
        }
        return true;
      case "email":
        if (!this.email) {
          toast.warning("Silahkan masukkan e-mail perusahaan.");
          return false;
        }
        if (!isEmail(this.email)) {
          toast.warning("Masukkan format e-mail perusahaan yang sesuai.");
          return false;
        }
        return true;
      case "phone":
        if (!this.phone) {
          toast.warning("Silahkan masukkan nomor telepon perusahaan.");
          return false;
        }
        if (
          this.phone.replace("+62", "0").length < 9 ||
          this.phone.replace("+62", "0").length > 13
        ) {
          toast.warning(
            "Silahkan masukkan format nomor telepon yang sesuai (10-13 digit)."
          );
          return false;
        }
        return true;
      case "logo":
        if (!this.logo) {
          toast.warning(
            "Silahkan unggah logo perusahaan (minimum 300x300 px)."
          );
          return false;
        }
        if (Math.round(this.logo?.size / 1024) > 5120) {
          toast.warning("Ukuran logo perusahaan tidak boleh lebih dari 5MB.");
          return false;
        }
        return true;
      case "province":
        if (!this.province) {
          toast.warning("Silahkan pilih provinsi.");
          return false;
        }
        return true;
      case "city":
        if (!this.city) {
          toast.warning("Silahkan pilih kota.");
          return false;
        }
        return true;
      case "description":
        if (!this.description) {
          toast.warning("Silahkan masukkan deskripsi.");
          return false;
        }
        return true;
      case "users": {
        let canNext = this.users.every((value, index) => {
          if (!value.name) {
            toast.warning(`Silahkan masukkan nama PIC ke-${index + 1}`);
            return false;
          }
          if (!value.position) {
            toast.warning(
              `Silahkan masukkan posisi/jabatan PIC ke-${index + 1}`
            );
            return false;
          }
          if (!value.email) {
            toast.warning(`Silahkan masukkan e-mail PIC ke-${index + 1}`);
            return false;
          }
          if (!isEmail(value.email)) {
            toast.warning(
              `Silahkan masukkan format email yang sesuai pada PIC ke-${
                index + 1
              }`
            );
            return false;
          }
          if (!value.phone) {
            toast.warning(
              `Silahkan masukkan nomor telepon PIC ke-${index + 1}`
            );
            return false;
          }
          if (
            (value.phone as string).replace("+62", "0").length < 9 ||
            (value.phone as string).replace("+62", "0").length > 13
          ) {
            toast.warning(
              `Silahkan masukkan format nomor telepon yang sesuai (10-13 digit) pada PIC ke-${
                index + 1
              }.`
            );
            return false;
          }
          return true;
        });
        let emails = this.users.map((value) => value.email.toLowerCase());
        if (emails.some((value, index) => emails.indexOf(value) !== index)) {
          toast.warning("Terdapat e-mail PIC yang sama di perusahaan ini.");
          return false;
        }
        let phones = this.users.map((value) => value.phone.toLowerCase());
        if (phones.some((value, index) => phones.indexOf(value) !== index)) {
          toast.warning(
            "Terdapat nomor telepon PIC yang sama di perusahaan ini."
          );
          return false;
        }
        return canNext;
      }
      case "isOnSite":
        if (this.isOnSite === "") {
          toast.warning("Silahkan pilih mekanisme perekrutan.");
          return false;
        }
        return true;
      case "boothNumber":
        if (this.isOrganization && !this.boothNumber) {
          toast.warning("Silahkan masukkan nomor booth yang diinginkan.");
          return false;
        }
        return true;
      case "paymentProof":
        if (this.isOrganization && !this.paymentProof) {
          toast.warning("Silahkan upload bukti bayar.");
          return false;
        }
        if (this.paymentProof) {
          let ext = this.getExt(this.paymentProof?.name);
          const extensions = [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "bmp",
            "gif",
            "svg",
            "webp",
            "doc",
            "docx",
            "zip",
            "rar",
          ];
          if (!extensions.includes(ext.toLowerCase())) {
            toast.warning(
              `Silahkan unggah file bukti bayar dengan format yang sesuai (${extensions.join(
                ", "
              )}).`
            );
            return false;
          }
          if (Math.round(this.paymentProof?.size / 1024) > 10240) {
            toast.warning(
              "Ukuran file bukti bayar tidak boleh lebih besar dari 10 MB."
            );
            return false;
          }
        }
        return true;
      case "npwp":
        if (this.isOrganization && !this.npwp) {
          toast.warning("Silahkan upload dokumen NPWP.");
          return false;
        }
        if (this.npwp) {
          let ext = this.getExt(this.npwp?.name);
          const extensions = [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "bmp",
            "gif",
            "svg",
            "webp",
            "doc",
            "docx",
            "zip",
            "rar",
          ];
          if (!extensions.includes(ext.toLowerCase())) {
            toast.warning(
              `Silahkan unggah file NPWP dengan format yang sesuai (${extensions.join(
                ", "
              )}).`
            );
            return false;
          }
          if (Math.round(this.npwp?.size / 1024) > 10240) {
            toast.warning(
              "Ukuran file NPWP tidak boleh lebih besar dari 10 MB."
            );
            return false;
          }
        }
        return true;
    }
  }

  private submit() {
    if (!this.validate("name")) return false;
    if (!this.validate("email")) return false;
    if (!this.validate("phone")) return false;
    if (!this.validate("logo")) return false;
    if (!this.validate("province")) return false;
    if (!this.validate("city")) return false;
    if (!this.validate("description")) return false;
    if (!this.validate("users")) return false;
    if (!this.validate("isOnSite")) return false;
    if (!this.validate("boothNumber")) return false;
    if (!this.validate("paymentProof")) return false;
    if (!this.validate("npwp")) return false;
    const formData = new FormData();
    formData.append("id", this.jobFair?.id);
    formData.append("name", this.name);
    formData.append("email", this.email.toLowerCase());
    formData.append("phone", this.phone);
    formData.append("logo", this.logo);
    formData.append("city_id", this.city?.id);
    formData.append("description", this.description);
    formData.append("is_on_site", Number(JSON.parse(this.isOnSite)).toString());
    formData.append("booth_number", this.boothNumber);
    if (this.paymentProof) formData.append("payment_proof", this.paymentProof);
    if (this.npwp) formData.append("npwp", this.npwp);
    formDataAppend(
      formData,
      this.users.map((value) => ({
        ...value,
        email: value.email.toLowerCase(),
      })),
      "users"
    );
    this.companyRegisterAdminJobFair({
      params: formData,
      success: () => {
        this.isSubmitted = true;
        this.scrollToElement("#form-register");
      },
    });
  }
}
